export default "__VITE_ASSET__BppQQ2_z__"